import { createSelector } from 'reselect';
import { IDevice, IDeviceState } from './types';

export const selectLoadedState = (state: IDeviceState) => state.loaded;
export const selectDevices = (state: IDeviceState) => state.devices;
export const selectSyncError = (state: IDeviceState) => state.error;
export const selectSyncState = (state: IDeviceState) => !!state.syncing;

export const selectIndexedDevices = createSelector(selectDevices, (devices) =>
  devices.reduce((indexed: { [key: string]: IDevice }, device: IDevice) => {
    if (device.id) {
      indexed[device.id] = device;
    }
    return indexed;
  }, {})
);
export const selectDevice = createSelector(
  [selectIndexedDevices, (_: IDeviceState, id: string) => id],
  (indexedDevices, id) => indexedDevices[id]
);
